app.controller('partnerController', function ($scope, safeApply) {

  $scope.route = 'partner'

  initComponents()
  
  // *************************************************************************
  // Leave this at the bottom - do not put any functions below this section **
  // *************************************************************************
  function initComponents() {
   
    // Menu sticky
    function windowScroll() {
      const navbar = document.getElementById("topnav");
      if(navbar!=null){
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      }
    }

    window.addEventListener('scroll', (ev) => {
        ev.preventDefault();
        windowScroll();
    })

    // back-to-top
    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
      scrollFunction();
    }
    function scrollFunction() {
      if(mybutton!=null){
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          mybutton.style.display = "block"
        } else {
          mybutton.style.display = "none"
        }
      }
    }

    $scope.topFunction = () => {
      document.body.scrollTop            = 0
      document.documentElement.scrollTop = 0
    }

  }   


})